(function($, root, undefined) {
    $(function() {
      let isProcessing = false; // Flag to track if the add to cart process is ongoing
        $('#email-verify').focusout(function(e) {
            e.preventDefault();
            var veriEmail = $(this).val();
            var email = $('#email').val();
            if (veriEmail == email) {
                $(this).removeClass('is-invalid');
            } else {
                $(this).addClass('is-invalid');
            }
        });

        $('.launch-event-form form .button').click(async function(e) { // Make this function async
             if (isProcessing) {
                  return; // Exit if the process is already running
              }
            if ($(this).parents('form').find('.is-invalid').length > 0) {
                e.preventDefault();
                $(this).parents('form').find('.is-invalid').focus();
                $('html, body').animate({
                    scrollTop: $($(this).parents('form').find('.is-invalid')).offset().top - 30
                }, 500);
                return; // Exit the function if validation fails
            }

            var fname = $('#first-name').val();
            var lname = $('#last-name').val();
            var email = $('#email').val();
            var g1name = $('#guest1-name').val();
            var g1Email = $('#guest1-email').val();
            var g2name = $('#guest2-name').val();
            var g2Email = $('#guest2-email').val();
            var g3name = $('#guest3-name').val();
            var g3Email = $('#guest3-email').val();
            var telPhone = $('#consultant-telephone').val();
            var consultantID = $('#consultant-id').val();

            if (fname && wbkCheckEmail(email)) {
                e.preventDefault(); // Prevent form submission since we're handling with AJAX
                isProcessing = true; // Set the flag to prevent further clicks
                await addProductToCart(46362917535972, fname, lname, email, telPhone, consultantID, g1name, g1Email, g2name, g2Email, g3name, g3Email); 
                // Call your async function to update the cart
                await updateCartWithGuestInfo(g1name, g1Email, g2name, g2Email, g3name, g3Email);
              
                window.location.href = '/checkout';
            }
        });
    });

    function wbkCheckEmail(val) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return val && re.test(val);
    }

async function addProductToCart(variantId, fname, lname, email, telPhone, consultantID, g1name, g1Email, g2name, g2Email, g3name, g3Email) {
    try {
        let quantityEvent = 1; // Default quantity
        if (g1name) {
            quantityEvent = 2; // Increment if Guest 1 has a value
        }
        if (g2name) {
            quantityEvent = 3; // Increment if Guest 2 also has a value
        }
        // Prepare the product data, including properties for registrant and guest information
        const productData = {
            id: variantId,
            quantity: quantityEvent,
            properties: {
                'Registrant Name': fname + ' ' + lname, // Combine first and last name
                'Registrant Email': email,
                'Registrant Phone Number': telPhone,
                'Registrant ID Number': consultantID

            }
        };

        // Include guest info if provided
        if (g1name && g1Email) {
            productData.properties['Guest 1 Name'] = g1name;
            productData.properties['Guest 1 Email'] = g1Email;
        }
        if (g2name && g2Email) {
            productData.properties['Guest 2 Name'] = g2name;
            productData.properties['Guest 2 Email'] = g2Email;
        }
        if (g3name && g3Email) {
            productData.properties['Guest 3 Name'] = g3name;
            productData.properties['Guest 3 Email'] = g3Email;
        }

        // Make the AJAX request to add the product to the cart with the registrant and guest info
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(productData) // Convert product data to JSON string
        });

        if (!response.ok) {
            // If the response is not OK, log the error
            throw new Error('Failed to add product to cart.');
        }

        // Here you can add any additional logic needed after successfully adding the product
        // For example, update the UI to reflect the item in the cart
    } catch (error) {
        // Log any errors to the console
        console.error('Error adding product to cart with registrant and guest info:', error);
    }
}

  
async function updateCartWithGuestInfo(g1name, g1Email, g2name, g2Email, g3name, g3Email) {
    try {
        const data = {
            attributes: {}
        };

        // Include guest info if provided
        if (g1name && g1Email) {
            data.attributes['Guest 1 Name'] = g1name;
            data.attributes['Guest 1 Email'] = g1Email; // Ensure these attribute keys match what your Shopify theme expects
        }
        if (g2name && g2Email) {
            data.attributes['Guest 2 Name'] = g2name;
            data.attributes['Guest 2 Email'] = g2Email;
        }
        if (g3name && g3Email) {
            data.attributes['Guest 3 Name'] = g3name;
            data.attributes['Guest 3 Email'] = g3Email;
        }

        // Make an AJAX request to update the cart
        const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data) // Convert the data object to a JSON string
        });

        if (!response.ok) {
            // If the response is not OK, throw an error
            throw new Error('Network response was not ok when attempting to update cart.');
        }

        // Convert the response to JSON
        const updatedCart = await response.json();
        console.log('Updated cart:', updatedCart); // Log the updated cart for debugging
    } catch (error) {
        console.error('Error updating cart with guest info:', error); // Log any errors
    }
}

})(jQuery, this);